import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IBlindLevelAndResumeDate } from '@soposopo/sopo-models/dist/tournament/Tournament.state';
import moment from 'moment';
import { IMultiDaySettingsInputOptions } from '../../dialog-input.service';

@Component({
    selector: 'app-multi-day-settings-input',
    templateUrl: './multi-day-settings-input.component.html',
    styleUrls: ['./multi-day-settings-input.component.scss'],
    standalone: false
})
export class MultiDaySettingsInputComponent implements OnInit {
    resumeDate = '';
    minTimeIsoString = '';
    maxTimeIsoString = '';
    blinds: string[] = [];
    disabledToIndex: number;
    blind: string;
    

    cancelText: string;
    okText: string;

    constructor(
        private dialogRef: MatDialogRef<MultiDaySettingsInputComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IMultiDaySettingsInputOptions
    ) {
        this.blinds = data.blinds;
        this.disabledToIndex = data.disabledToIndex;
        if (data.okText) this.okText = data.okText;
        if (data.cancelText) this.cancelText = data.cancelText;
        this.setMinMaxResumeTime(new Date(data.minTimeString));
    }

    ngOnInit() {
    }

    setMinMaxResumeTime(date: Date) {
        date.setSeconds(0);
        date.setMilliseconds(0);

        const isoString = moment(date).toISOString(true);

        this.resumeDate = isoString;
        this.minTimeIsoString = isoString;

        date.setFullYear(date.getFullYear() + 1);

        this.maxTimeIsoString = moment(date).toISOString(true);
    }

    confirm() {
        const result: IBlindLevelAndResumeDate = {
            blindLevelToStopAt: this.blind,
            resumeDate: new Date(this.resumeDate).getTime(),
        }
        console.log(result);
        this.dialogRef.close(result);
    }

    cancel () {
        this.dialogRef.close(undefined);
    }
}
